import { Location, LocationStrategy } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Injectable, NgZone } from '@angular/core';
import { ApiService } from 't4core';
import { Route, Router } from '@angular/router';

@Injectable({
  providedIn: 'root',
})

export class AnalyticsService {

  constructor(private Api: ApiService, public router: Router) { }

  //public async trackPageHit() {
  //  try {
  //    const pattern = await this.getBrowserInfo();
  //    console.log("page hit pattern", pattern);
  //    const payload = {
  //      pattern: pattern,
  //      keyparameter: window.location.pathname.split(';')[0],
  //      querystring: window.location.href.split(';')[1]
  //    };
  //    var result = await this.Api.post<any>("/Settings/saveShortLinkHits", payload);
  //  } catch (err) {
  //    console.error("Analytics page hit failed", err);
  //  }
  //}

  public async getBrowserInfo(): Promise<string>{
    const uaData: any = (navigator as any).userAgentData;
    const browserBrand = this.getBrowserName();
    const browserVersion = this.getBrowserVersion();
    const platform = this.getOS();
    const language = navigator.language;
    const languages = navigator.languages?.join(',') || '';
    const isMobile = uaData?.mobile || /Mobi/i.test(navigator.userAgent) ? 1 : 0;
    const cssGrid = CSS.supports('display', 'grid') ? 1 : 0;
    const cssLab = CSS.supports('color', 'lab(0 0 0)') ? 1 : 0;
    const cssTextBalance = CSS.supports('text-wrap', 'balance') ? 1 : 0;
    const darkMode = window.matchMedia('(prefers-color-scheme: dark)').matches ? 1 : 0;
    return [browserBrand,
      browserVersion,
      platform,
      language,
      languages,
      isMobile,
      cssGrid,
      cssLab,
      cssTextBalance,
      darkMode
    ].join('|');
  }

  private getBrowserName(): string {
    const uaData: any = (navigator as any).userAgentData;
    if (uaData?.brands) {
      const brands = uaData.brands.map((b: any) => b.brand.toLowerCase());
      if (brands.some(b => b.includes("chrome"))) return "Chrome";
      if (brands.some(b => b.includes("edge"))) return "Edge";
      if (brands.some(b => b.includes("opera"))) return "Opera";
    }
    const ua = navigator.userAgent;
    if (/edg/i.test(ua)) return "Edge";
    if (/chrome|crios|chromium/i.test(ua)) return "Chrome";
    if (/safari/i.test(ua) && !/chrome/i.test(ua)) return "Safari";
    if (/firefox|fxios/i.test(ua)) return "Firefox";
    if (/opr\//i.test(ua)) return "Opera";
    return "Unknown";
  }
  private getBrowserVersion(): string {
    const uaData: any = (navigator as any).userAgentData;
    if (uaData?.brands) {
      const realBrand = uaData.brands.find((b: any) =>
        b.brand !== "Not_A Brand"
      );
      if (realBrand) {
        return realBrand.version.split('.')[0];
      }
    }

    const match = navigator.userAgent.match(/(Chrome|Firefox|Version|Edg)\/(\d+)/);
    return match ? match[2] : "0";
  }
  private getOS(): string {
    const ua = navigator.userAgent;
    if (/iPhone|iPad|iPod/i.test(ua)) return "iOS";
    if (/Android/i.test(ua)) return "Android";
    // iPadOS Safari reports "MacIntel"
    if (/Macintosh/i.test(ua) && 'ontouchend' in document) return "iPadOS";
    // Desktop OS
    if (/Mac OS X|Macintosh/i.test(ua)) return "macOS";
    if (/Win/i.test(ua)) return "Windows";
    if (/Linux/i.test(ua)) return "Linux";
    return "Unknown";
  }
}
